export const FETCH_REPORT_DETAILS = 'src/Corporate/report/action/Fetch_Report_Details';
export const FETCH_REPORT_DETAILS_SUCCESS = 'src/Corporate/report/action/Fetch_Report_Details_Success';
export const FETCH_REPORT_DETAILS_FAILURE = 'src/Corporate/report/action/Fetch_Report_Details_Failure';
export const fetchReportDetails = (data) => {
    return {
        type: FETCH_REPORT_DETAILS,
        data
    }
}
export const fetchReportDetailsSuccess = (data) => {
    return {
        type: FETCH_REPORT_DETAILS_SUCCESS,
        data
    }
}
export const fetchReportDetailsFailure = (data) => {
    return {
        type: FETCH_REPORT_DETAILS_FAILURE,
        data
    }
}